import { render, staticRenderFns } from "./Ramp.vue?vue&type=template&id=ba681a04&scoped=true&"
import script from "./Ramp.vue?vue&type=script&lang=js&"
export * from "./Ramp.vue?vue&type=script&lang=js&"
import style0 from "./Ramp.vue?vue&type=style&index=0&id=ba681a04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba681a04",
  null
  
)

export default component.exports